export default "__VITE_ASSET__fb96fe95__"